import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig } from '../../models/https';
import { IGetPaymentLinkDataRequest } from '../../models/trackPage/getPaymentLink.model';
import { paymentLinkActions } from '../../redux/slices/paymentLinkSlice';
import { useAppDisPatch } from '../../redux/store';
import useHttps from '../useHttps';

const useGetPaymentLink = () => {
  const dispatch = useAppDisPatch();
  const request = useHttps();
  const [paymewntLink, setPaymentLink] = useState<string | null>(null);

  const [paymentLinkloading, setPaymentLinkLoading] = useState(false);

  const onPaymentLinkError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Error occured while generating payment link'
    );
  };

  const onPaymentLinkSuccess = (data: any) => {
    dispatch(paymentLinkActions.setPaymentLink({ paymentLink: data }));
    setPaymentLink(data?.data);
  };

  const getPaymentLink = (data: IGetPaymentLinkDataRequest) => {
    const url: HttpConfig = {
      url: `general-service/external/packages/payment`,
      method: 'post',
      data,
    };

    request(
      url,
      onPaymentLinkSuccess,
      setPaymentLinkLoading,
      onPaymentLinkError
    );
  };

  return { getPaymentLink, paymentLinkloading, paymewntLink };
};

export default useGetPaymentLink;
